// @flow
import defaultState from '../defaultState';
import type { DefaultUserState as State } from '../types';

const defaultCurrentUser = defaultState.currentUser;

type Action = { type: 'UPDATE_CURRENT_USER', user: Object };

export default function currentUser(
  state: State = defaultCurrentUser,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_USER':
      return {
        ...state,
        ...action.user.user,
        settings: { ...action.user.settings }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_USER_SETTINGS':
      return {
        ...state,
        settings: action.settings
      };

    // $FlowFixMe
    case 'GET_ALLOCATED_USER_ORGANISATIONS':
      return {
        ...state,
        organisations:
          {
            ...state.organisations,
            allocated: action.organisations
          } || []
      };

    // $FlowFixMe
    case 'GET_UNALLOCATED_USER_ORGANISATIONS':
      return {
        ...state,
        organisations:
          {
            ...state.organisations,
            unallocated: action.organisations.unallocatedOrganisations
          } || []
      };

    // $FlowFixMe
    case 'CLEAR_CURRENT_USER':
      return defaultCurrentUser;

    // $FlowFixMe
    case 'GET_USER_LOCATIONS':
      return {
        ...state,
        locations: action.locations
      };

    // $FlowFixMe
    case 'LOGOUT':
      return defaultCurrentUser;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentUser.js